// 引入api
import { fun_Download } from "@/api";
export default {
  // 数据存储
  data: () => {
    // 返回
    return {
      // 默认关闭弹窗
      dialogVisible: false,
      // 标题
      title: null,
      // pdf路径
      pdfUrl: null,
    };
  },

  // 模板编译完成
  mounted() {
  },

  // 自定义方法
  methods: {
    // 打开弹框时调用
    async fun_GetOpen() {
      // 预览PDF
      this.fun_Look();
    },
    /**
     * 预览PDF
     */
    fun_Look() {
      // 获取id
      fun_Download("/downloadLocal?filePath=" + this.pdfUrl).then(res => {
        // 存储this
        const data = new Blob([res.data], { type: "application/pdf" });
        // 预览PDF
        this.pdfUrl = "./static/pdf/web/viewer.html?file=" + encodeURIComponent(URL.createObjectURL(data));
      });
    },
    /**
     * 弹窗关闭的事件
     * @author shuhua
     */
    fun_HandleClose() {
      // pdf路径
      this.$refs.iframe.src = null;
    }
  }
};
